import type { ReactNode } from 'react';

import { useSession } from '../../hooks/useSession';
import useClientAuthSsoRedirectQuery from '../../queries/useClientAuthSsoRedirectQuery';

interface SessionGuardProps {
  children: ReactNode;
}

const SessionGuard = ({ children }: SessionGuardProps) => {
  const { isLogin, isSessionLoading } = useSession({
    refetchOnWindowFocus: false,
  });
  useClientAuthSsoRedirectQuery({ enabled: isLogin });

  return <>{!isLogin && !isSessionLoading && children}</>;
};

export default SessionGuard;
